import { render, staticRenderFns } from "./EmojiFilterItem.vue?vue&type=template&id=dd25243e&"
import script from "./EmojiFilterItem.vue?vue&type=script&lang=js&"
export * from "./EmojiFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports